import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiNotFoundError extends TmApiClientError {
  public name = 'TmApiNotFoundError'

  protected override code: TmTransportHttpErrorCode = 404

  protected override isMonitored = false
}
